// extracted by mini-css-extract-plugin
module.exports = {"label":"CardRadio_label__2PRde","withCardIcon":"CardRadio_withCardIcon__kSINV","isDisabled":"CardRadio_isDisabled__2h_Zo","checkedLabel":"CardRadio_checkedLabel__aCjXe"};